unit RemittancesEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  XData.Web.JsonDataset,
  XData.Dataset.Utils;

type
  TRemittanceEditForm = class(TBaseEditForm)
    SchoolSource: TDataSource;
    InvoiceSource: TDataSource;
    PaymentMethodList: TDBComboBox;
    PaymentStateList: TDBComboBox;
    PaymentKindList: TDBComboBox;
    RemittanceDate: TDBDateTimePicker;
    PaymentRef: TDBEdit;
    RemittanceAmount: TDBEdit;
    SchoolNameList: TDBLookupComboBox;
    InvoiceList: TDBLookupComboBox;
    InvoiceGrossAmount: TDBEdit;
    SchoolIdList: TDBLookupComboBox;
    SchoolURNList: TDBLookupComboBox;
    procedure OnChange_SelectedSchool(Sender: TObject);
    procedure OnEnter_Dropdown(Sender: TObject);
  private
    { Private declarations }
    FChangingSchool: Boolean;
    FSaveSuccessful: Boolean;
    FSaveErrorMessage: string;
    FHandbookSent: Boolean;
    FIsInsert: Boolean;
    
    procedure RemittanceLookupBeforePost(DataSet: TDataSet);

    [async]
    function SendHandbook: Boolean; async;

    [async]
    function SendPaymentConfirmation: Boolean; async;

    [async]
    procedure SendDocumentsAfterSave; async;

  protected
    function GetRequiredEditLevel: string; override;

    procedure BeforePostRecord; override;
    procedure AfterPostRecord; override;
    procedure AfterApplyUpdates(Sender: TDataset; Info: TResolveResults); override;

  public
    { Public declarations }

    [async]
    procedure InitForm; async; override;

    [async]
    procedure LoadInvoices; async;

    procedure Save;
    procedure SaveButtonClick(Sender: TObject);

    property IsInsert: Boolean read FIsInsert write FIsInsert;

  protected procedure LoadDFMValues; override; end;

var
  RemittanceEditForm: TRemittanceEditForm;

implementation

{$R *.dfm}

uses
  RemittancesListPage,
  MainDataModule,
  Rtti,
  CRM.Enumerations,
  App.Shared,
  XData.Web.Client,
  XData.Web.Dataset,
  Auth.Service;

procedure TRemittanceEditForm.InitForm;
var
  oPaymentMethod: TPaymentMethod;
  oPaymentState: TPaymentState;
  oPaymentKind: TPaymentKind;

begin
  WaitMessage.Show;
  try
    inherited;

    // pre-populate dropdowns when initializing the form
  for oPaymentMethod := Low(TPaymentMethod) to High(TPaymentMethod) do
    PaymentMethodList.Items.Add(TRttiEnumerationType.GetName<TPaymentMethod>(oPaymentMethod));

  for oPaymentState := Low(TPaymentState) to High(TPaymentState) do
  begin
    case oPaymentState of
      TPaymentState.New,
      TPaymentState.Reconciled,
      TPaymentState.Cancelled:
        PaymentStateList.Items.Add(TRttiEnumerationType.GetName<TPaymentState>(oPaymentState));

    end;

  end;

  for oPaymentKind := Low(TPaymentKind) to High(TPaymentKind) do
    PaymentKindList.Items.Add(TRttiEnumerationType.GetName<TPaymentKind>(oPaymentKind));

  // assign datasets
  SchoolSource.DataSet := MainData.SchoolLookUp;
  InvoiceSource.DataSet := MainData.InvoiceLookup;

  PaymentMethodList.OnEnter := OnEnter_Dropdown;
  PaymentStateList.OnEnter := OnEnter_Dropdown;
  PaymentKindList.OnEnter := OnEnter_Dropdown;

  // Set up BeforePost event handler
  if Assigned(DataSource) and Assigned(DataSource.DataSet) then
    DataSource.DataSet.BeforePost := RemittanceLookupBeforePost;

  // Automatically load invoices if school and invoice id are already set
  if Assigned(DataSource) and Assigned(DataSource.DataSet) and DataSource.DataSet.Active then
  begin
    try
      // Check if SchoolId is set and valid
      if not DataSource.DataSet.FieldByName('SchoolId').IsNull and 
         (DataSource.DataSet.FieldByName('SchoolId').AsInteger > 0) then
      begin
        // Check if InvoiceId is also set
        if not DataSource.DataSet.FieldByName('InvoiceId').IsNull and 
           (DataSource.DataSet.FieldByName('InvoiceId').AsInteger > 0) then
        begin
          // Both school and invoice are set, load the invoices for this school
          Await(LoadInvoices);

        end;

      end;

    except
      // Silently handle any errors (field might not exist or dataset not ready)

    end;

  end;

  finally
    WaitMessage.Hide;
  end;

end;

procedure TRemittanceEditForm.OnEnter_Dropdown(Sender: TObject);
begin
  if Assigned(DataSource) and Assigned(DataSource.DataSet) and
     (DataSource.DataSet.State = dsBrowse) and not FIsInsert then
    DataSource.DataSet.Edit;

end;

procedure TRemittanceEditForm.OnChange_SelectedSchool(Sender: TObject);
begin
  inherited;

  if FChangingSchool then
    Exit;

  // refresh invoices if school changed
  FChangingSchool := True;
  if TDBLookupComboBox(Sender).ItemIndex <> -1 then
    LoadInvoices;

  FChangingSchool := False;

end;

procedure TRemittanceEditForm.LoadInvoices;
begin
  // load invoices for school
  Await(MainData.LoadInvoices(DataSource.DataSet.FieldByName('SchoolId').AsInteger));

end;

function TRemittanceEditForm.GetRequiredEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

procedure TRemittanceEditForm.Save;
var
  iInvoiceId, iSchoolId: Integer;
  sErrorMessage: string;
  slErrors: TStringList;

begin
  FSaveMessagesHandled := False;

  // First, check base class validation
  if not CanSaveThis then
  begin
    if not FSaveMessagesHandled then
    begin
      ShowMessage('Some details need completing before you can save this');

    end
    else
      FSaveMessagesHandled := False;

    Exit;

  end;

  // peform validations
  slErrors := TStringList.Create;
  slErrors.Delimiter := ',';

  // school and invoice id 'should' be on the dataset at this point
  iSchoolId := DataSource.DataSet.FieldByName('SchoolId').AsInteger;
  iInvoiceId := DataSource.DataSet.FieldByName('InvoiceId').AsInteger;
  
  if iSchoolId <= 0 then
    slErrors.Add('School must be selected');

  if (InvoiceList.ItemIndex = -1) and (iInvoiceId <= 0) then
    slErrors.Add('Invoice must be selected');

  if (PaymentKindList.ItemIndex = -1) and (DataSource.DataSet.FieldByName('PaymentKind').AsString = '') then
    slErrors.Add('Payment Kind must be selected');

  if (PaymentMethodList.ItemIndex = -1) and (DataSource.DataSet.FieldByName('PaymentMethod').AsString = '') then
    slErrors.Add('Payment Method must be selected');

  if PaymentRef.Text = '' then
    slErrors.Add('Payment Reference must be entered');

  if RemittanceDate.DateTime = 0 then
    slErrors.Add('Remittance date must be entered');

  if RemittanceAmount.Text = '' then
    slErrors.Add('Payment Amount must be entered');

  if (PaymentStateList.ItemIndex = -1) and (DataSource.DataSet.FieldByName('PaymentState').AsString = '') then
    slErrors.Add('Payment State must be selected');

  // generate error message
  sErrorMessage := StringReplace(slErrors.DelimitedText, ',', ', ', [rfReplaceAll]);
  slErrors.Free;

  if sErrorMessage <> '' then
  begin
    ShowMessage(sErrorMessage);
    Exit;

  end;
  
  // For new records, ensure dataset is in Insert mode
  // For existing records, ensure dataset is in Edit mode
  if DataSource.DataSet.State = dsBrowse then
  begin
    if FIsInsert then
      DataSource.DataSet.Insert
    else
      DataSource.DataSet.Edit;

  end
  else if not (DataSource.DataSet.State in dsEditModes) then
  begin
    ShowMessage('Dataset is not in a valid state for saving');
    Exit;

  end;
  
  // proceed with save if validation passes
  try
    BeforePostRecord;
    
    // Ensure dataset is still in Edit/Insert mode after BeforePostRecord
    if not (DataSource.DataSet.State in dsEditModes) then
    begin
      ShowMessage('Dataset state changed during validation. Cannot save.');
      Exit;

    end;
    
    // For new records, ensure we're still in Insert mode
    if (DataSource.DataSet.State = dsBrowse) and FIsInsert then
      DataSource.DataSet.Insert;
    
    DataSource.Dataset.Post;
    AfterPostRecord;

  except
    on E: Exception do
    begin
      ShowMessage('Error saving remittance: ' + E.Message);

      // Cancel any pending changes
      if DataSource.DataSet.State in dsEditModes then
        DataSource.DataSet.Cancel;

      Exit;

    end;

  end;

  // apply updates to trigger AfterApplyUpdates and document sending
  TXDataWebDataSet(Dataset).ApplyUpdates;

  if CloseOnSave then
  begin
    ShowAToast(SaveTitle, SaveDescription, 'ok.png');
    WaitMessage.Show;
    CloseTimer.Enabled := True;

  end;

end;

procedure TRemittanceEditForm.SaveButtonClick(Sender: TObject);
begin
  Save;

end;

procedure TRemittanceEditForm.BeforePostRecord;
begin
  inherited;
  
  // Capture whether this is a new record before saving
  FIsInsert := (DataSource.State = dsInsert);
  
end;

procedure TRemittanceEditForm.AfterPostRecord;
begin
  // initialize save tracking variables
  FSaveSuccessful := False;
  FSaveErrorMessage := '';

  // apply updates to actually save to database,
  // the AfterApplyUpdates method will handle the document sending
  TXDataWebDataSet(Dataset).ApplyUpdates;

end;

procedure TRemittanceEditForm.RemittanceLookupBeforePost(DataSet: TDataSet);
var
  oIdField, oDateAddedField, oAddedByField, oLastUpdatedField, oLastUpdatedByField: TField;
  iUserId: Integer;

begin
  // Get current user ID for audit fields
  try
    // Try PersonId first (returns Integer directly)
    iUserId := AuthService.PersonId;
    if iUserId = 0 then
    begin
      // Fallback to UserId (returns string, need to convert)
      iUserId := StrToIntDef(AuthService().UserId, 0);

    end;

  except
    iUserId := 0;

  end;
  
  // For new records in Insert mode, set required fields
  if DataSet.State = dsInsert then
  begin
    try
      // Set Id to 0 if it's null/empty
      oIdField := DataSet.FieldByName('Id');
      if oIdField.IsNull or (oIdField.AsString = '') or (oIdField.AsInteger <= 0) then
        oIdField.AsInteger := 0;
      
      // Set DateAdded if null/empty
      oDateAddedField := DataSet.FieldByName('DateAdded');
      if oDateAddedField.IsNull or (oDateAddedField.AsDateTime = 0) then
        oDateAddedField.AsDateTime := Now;
      
      // Set AddedBy if null/empty
      oAddedByField := DataSet.FieldByName('AddedBy');
      if oAddedByField.IsNull or (oAddedByField.AsInteger <= 0) then
      begin
        if iUserId > 0 then
          oAddedByField.AsInteger := iUserId
        else
          // If we can't get user ID, set to 0 as a default
          // The server should handle this, but we need to satisfy client-side validation
          oAddedByField.AsInteger := 0;

      end;
      
    except
      // Silently handle errors - let validation catch any real issues

    end;

  end
  // For existing records in Edit mode, set LastUpdated fields
  else if DataSet.State = dsEdit then
  begin
    try
      // Set LastUpdated if null/empty
      oLastUpdatedField := DataSet.FieldByName('LastUpdated');
      if oLastUpdatedField.IsNull or (oLastUpdatedField.AsDateTime = 0) then
        oLastUpdatedField.AsDateTime := Now;
      
      // Set LastUpdatedBy if null/empty
      oLastUpdatedByField := DataSet.FieldByName('LastUpdatedBy');
      if oLastUpdatedByField.IsNull or (oLastUpdatedByField.AsInteger <= 0) then
      begin
        if iUserId > 0 then
          oLastUpdatedByField.AsInteger := iUserId;

      end;
      
    except
      // Silently handle errors - let validation catch any real issues

    end;

  end;
  
end;

procedure TRemittanceEditForm.AfterApplyUpdates(Sender: TDataset; Info: TResolveResults);
var
  iIdx: Integer;
  bHasErrors: Boolean;

begin
  inherited;

  // Check if the save was successful by examining each record for errors
  bHasErrors := False;
  FSaveErrorMessage := '';
  
  for iIdx := 0 to Length(Info.Records) - 1 do
  begin
    if Info.Records[iIdx].Error <> '' then
    begin
      bHasErrors := True;
      if FSaveErrorMessage <> '' then
        FSaveErrorMessage := FSaveErrorMessage + '; ';
      FSaveErrorMessage := FSaveErrorMessage + Info.Records[iIdx].Error;

    end;

  end;
  
  FSaveSuccessful := not bHasErrors;
  
  if not FSaveSuccessful then
  begin
    ShowMessage('Failed to save remittance: ' + FSaveErrorMessage);
    Exit;

  end;
  
  // Push back the ID from server to local dataset (crucial for new records)
  TXDataDSUtils.UpdateAllIds(TXDataWebDataSet(Sender), Info, 'Id', True);
  
  // only send documents if save was successful
  if FSaveSuccessful then
  begin
    // start async document sending process
    SendDocumentsAfterSave;

  end;

end;

procedure TRemittanceEditForm.SendDocumentsAfterSave;
var
  bSuccess: Boolean;
  sMessage: string;
  sErrorMessage: string;

begin
  // send appropriate document based on payment state and wait for completion
  if Dataset.FieldByName('PaymentState').AsString = Payment_State[TPaymentState.Reconciled] then
  begin
    bSuccess := Await(SendHandbook);
    sErrorMessage := FSaveErrorMessage;
    if bSuccess then
    begin
      if FHandbookSent then
        sMessage := 'Remittance saved and handbook sent successfully'
      else
        sMessage := 'Remittance saved';

    end
    else
    begin
      if sErrorMessage <> '' then
        sMessage := 'Remittance saved but failed to send handbook: ' + sErrorMessage
      else
        sMessage := 'Remittance saved but failed to send handbook';

    end;

  end
  else if Dataset.FieldByName('PaymentState').AsString = Payment_State[TPaymentState.New] then
  begin
    // Only send payment confirmation for new records, not updates
    if FIsInsert then
    begin
      bSuccess := Await(SendPaymentConfirmation);
      sErrorMessage := FSaveErrorMessage;
      if bSuccess then
        sMessage := 'Remittance saved and payment confirmation job created successfully'
      else
      begin
        if sErrorMessage <> '' then
          sMessage := 'Remittance saved but failed to create payment confirmation job: ' + sErrorMessage
        else
          sMessage := 'Remittance saved but failed to create payment confirmation job';

      end;
    end
    else
    begin
      // This is an update to an existing record, no confirmation needed
      sMessage := 'Remittance updated successfully';
      
    end;

  end
  else
    sMessage := 'Remittance saved successfully';
  
  ShowMessage(sMessage);

end;

function TRemittanceEditForm.SendHandbook: Boolean;
var
  oClientResponse: TXDataClientResponse;
  bSuccess: Boolean;
  jsoClientResponse: TJSObject;
  bHandbookSent: Boolean;
  jsaServerResponses: TJSArray;
  jsoServerResponse: TJSObject;

begin
  inherited;

  // Clear any previous error message
  FSaveErrorMessage := '';
  FHandbookSent := False;

  // if invoice not already had the handbook sent, then send it
  bHandbookSent := False;
  if InvoiceSource.Dataset.FieldByName('HandbookSent').AsString <> '' then
    bHandbookSent := InvoiceSource.Dataset.FieldByName('HandbookSent').AsBoolean;

  if not bHandbookSent then
  begin
    try
      // send the handbook out
      oClientResponse := Await(
        TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync(
          'ISchoolService.SendHandbook',
          [ InvoiceSource.Dataset.FieldByName(FIdField).AsString ]
        )
      );

      jsoClientResponse := oClientResponse.ResultAsObject;
      
      // Parse TServerResponseList structure
      if jsoClientResponse.hasOwnProperty('ServerResponses') then
      begin
        jsaServerResponses := JS.toArray(jsoClientResponse['ServerResponses']);
        if jsaServerResponses.Length > 0 then
        begin
          jsoServerResponse := JS.toObject(jsaServerResponses[0]);
          bSuccess := JS.toBoolean(jsoServerResponse['Success']);
          FSaveErrorMessage := string(jsoServerResponse['Status']);

          FHandbookSent := bSuccess;

        end
        else
        begin
          bSuccess := False;
          FSaveErrorMessage := 'No server response received';

        end;

      end
      else
      begin
        bSuccess := False;
        FSaveErrorMessage := 'Invalid server response format';

      end;

      Result := bSuccess;

    except
      on E: Exception do
      begin
        FSaveErrorMessage := E.Message;
        Result := False;

      end;

    end;

  end
  else
  begin
    Result := True;

  end;

end;

function TRemittanceEditForm.SendPaymentConfirmation: Boolean;
var
  oClientResponse: TXDataClientResponse;
  bSuccess: Boolean;
  jsoResponse: TJSObject;
  jsaResponses: TJSArray;
  jsoServerResponse: TJSObject;

begin
  inherited;

  // Clear any previous error message
  FSaveErrorMessage := '';

  try
    // send payment confirmation
    oClientResponse := Await(
      TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        'ISchoolService.SendPaymentConfirmationLetter',
        [ Dataset.FieldByName(FIdField).AsString ]
      )
    );

    jsoResponse := oClientResponse.ResultAsObject;
    
    // Parse TServerResponseList structure
    if jsoResponse.hasOwnProperty('ServerResponses') then
    begin
      jsaResponses := JS.toArray(jsoResponse['ServerResponses']);
      if jsaResponses.Length > 0 then
      begin
        jsoServerResponse := JS.toObject(jsaResponses[0]);
        bSuccess := JS.toBoolean(jsoServerResponse['Success']);
        FSaveErrorMessage := string(jsoServerResponse['Status']);

      end
      else
      begin
        bSuccess := False;
        FSaveErrorMessage := 'No server response received';

      end;

    end
    else
    begin
      bSuccess := False;
      FSaveErrorMessage := 'Invalid server response format';

    end;

    Result := bSuccess;

  except
    on E: Exception do
    begin
      FSaveErrorMessage := E.Message;
      Result := False;

    end;

  end;

end;

procedure TRemittanceEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PaymentMethodList := TDBComboBox.Create('payment-method');
  PaymentStateList := TDBComboBox.Create('payment-state');
  PaymentKindList := TDBComboBox.Create('payment-kind');
  RemittanceDate := TDBDateTimePicker.Create('remittance-date');
  PaymentRef := TDBEdit.Create('payment-ref');
  RemittanceAmount := TDBEdit.Create('remittance-amount');
  SchoolNameList := TDBLookupComboBox.Create('school-name-list');
  InvoiceList := TDBLookupComboBox.Create('invoice-id');
  InvoiceGrossAmount := TDBEdit.Create('invoice-gross-amount');
  SchoolIdList := TDBLookupComboBox.Create('school-id-list');
  SchoolURNList := TDBLookupComboBox.Create('school-urn-list');
  SchoolSource := TDataSource.Create(Self);
  InvoiceSource := TDataSource.Create(Self);

  PaymentMethodList.BeforeLoadDFMValues;
  PaymentStateList.BeforeLoadDFMValues;
  PaymentKindList.BeforeLoadDFMValues;
  RemittanceDate.BeforeLoadDFMValues;
  PaymentRef.BeforeLoadDFMValues;
  RemittanceAmount.BeforeLoadDFMValues;
  SchoolNameList.BeforeLoadDFMValues;
  InvoiceList.BeforeLoadDFMValues;
  InvoiceGrossAmount.BeforeLoadDFMValues;
  SchoolIdList.BeforeLoadDFMValues;
  SchoolURNList.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  SchoolSource.BeforeLoadDFMValues;
  InvoiceSource.BeforeLoadDFMValues;
  try
    Caption := 'MainData.InvoiceLookup';
    PaymentMethodList.SetParentComponent(Self);
    PaymentMethodList.Name := 'PaymentMethodList';
    PaymentMethodList.Left := 354;
    PaymentMethodList.Top := 173;
    PaymentMethodList.Width := 145;
    PaymentMethodList.Height := 23;
    PaymentMethodList.ElementClassName := 'form-select';
    PaymentMethodList.ElementFont := efCSS;
    PaymentMethodList.HeightStyle := ssAuto;
    PaymentMethodList.HeightPercent := 100.000000000000000000;
    PaymentMethodList.Style := csDropDown;
    PaymentMethodList.Text := 'PaymentMethodList';
    PaymentMethodList.WidthPercent := 100.000000000000000000;
    PaymentMethodList.ItemIndex := -1;
    PaymentMethodList.DataField := 'PaymentMethod';
    PaymentMethodList.DataSource := DataSource;
    PaymentStateList.SetParentComponent(Self);
    PaymentStateList.Name := 'PaymentStateList';
    PaymentStateList.Left := 54;
    PaymentStateList.Top := 201;
    PaymentStateList.Width := 145;
    PaymentStateList.Height := 23;
    PaymentStateList.ElementClassName := 'form-select';
    PaymentStateList.ElementFont := efCSS;
    PaymentStateList.HeightStyle := ssAuto;
    PaymentStateList.HeightPercent := 100.000000000000000000;
    PaymentStateList.Style := csDropDown;
    PaymentStateList.Text := 'PaymentStateList';
    PaymentStateList.WidthPercent := 100.000000000000000000;
    PaymentStateList.ItemIndex := -1;
    PaymentStateList.DataField := 'PaymentState';
    PaymentStateList.DataSource := DataSource;
    PaymentKindList.SetParentComponent(Self);
    PaymentKindList.Name := 'PaymentKindList';
    PaymentKindList.Left := 354;
    PaymentKindList.Top := 202;
    PaymentKindList.Width := 145;
    PaymentKindList.Height := 23;
    PaymentKindList.ElementClassName := 'form-select';
    PaymentKindList.ElementFont := efCSS;
    PaymentKindList.HeightStyle := ssAuto;
    PaymentKindList.HeightPercent := 100.000000000000000000;
    PaymentKindList.Style := csDropDown;
    PaymentKindList.Text := 'PaymentKindList';
    PaymentKindList.WidthPercent := 100.000000000000000000;
    PaymentKindList.ItemIndex := -1;
    PaymentKindList.DataField := 'PaymentKind';
    PaymentKindList.DataSource := DataSource;
    RemittanceDate.SetParentComponent(Self);
    RemittanceDate.Name := 'RemittanceDate';
    RemittanceDate.Left := 54;
    RemittanceDate.Top := 230;
    RemittanceDate.Width := 145;
    RemittanceDate.Height := 22;
    RemittanceDate.ElementClassName := 'form-control';
    RemittanceDate.HeightStyle := ssAuto;
    RemittanceDate.WidthStyle := ssAuto;
    RemittanceDate.BorderStyle := bsSingle;
    RemittanceDate.ChildOrder := 14;
    RemittanceDate.Color := clWhite;
    RemittanceDate.Date := 45882.618356574070000000;
    RemittanceDate.ElementFont := efCSS;
    RemittanceDate.ElementPosition := epIgnore;
    RemittanceDate.Role := '';
    RemittanceDate.Text := '';
    RemittanceDate.DataField := 'RemittanceDate';
    RemittanceDate.DataSource := DataSource;
    PaymentRef.SetParentComponent(Self);
    PaymentRef.Name := 'PaymentRef';
    PaymentRef.Left := 354;
    PaymentRef.Top := 230;
    PaymentRef.Width := 145;
    PaymentRef.Height := 22;
    PaymentRef.ChildOrder := 15;
    PaymentRef.ElementClassName := 'form-control';
    PaymentRef.ElementFont := efCSS;
    PaymentRef.ElementPosition := epIgnore;
    PaymentRef.HeightStyle := ssAuto;
    PaymentRef.HeightPercent := 100.000000000000000000;
    PaymentRef.MaxLength := 50;
    PaymentRef.Text := 'PaymentRef';
    PaymentRef.WidthStyle := ssAuto;
    PaymentRef.WidthPercent := 100.000000000000000000;
    PaymentRef.DataField := 'PaymentRef';
    PaymentRef.DataSource := DataSource;
    RemittanceAmount.SetParentComponent(Self);
    RemittanceAmount.Name := 'RemittanceAmount';
    RemittanceAmount.Left := 54;
    RemittanceAmount.Top := 258;
    RemittanceAmount.Width := 121;
    RemittanceAmount.Height := 22;
    RemittanceAmount.ChildOrder := 16;
    RemittanceAmount.EditType := weFloat;
    RemittanceAmount.ElementClassName := 'form-control';
    RemittanceAmount.ElementFont := efCSS;
    RemittanceAmount.ElementPosition := epIgnore;
    RemittanceAmount.HeightStyle := ssAuto;
    RemittanceAmount.HeightPercent := 100.000000000000000000;
    RemittanceAmount.WidthStyle := ssAuto;
    RemittanceAmount.WidthPercent := 100.000000000000000000;
    RemittanceAmount.DataField := 'Amount';
    RemittanceAmount.DataSource := DataSource;
    SchoolNameList.SetParentComponent(Self);
    SchoolNameList.Name := 'SchoolNameList';
    SchoolNameList.Left := 135;
    SchoolNameList.Top := 145;
    SchoolNameList.Width := 250;
    SchoolNameList.Height := 22;
    SchoolNameList.ElementClassName := 'form-select form-control';
    SchoolNameList.ElementFont := efCSS;
    SchoolNameList.ElementPosition := epIgnore;
    SchoolNameList.HeightPercent := 100.000000000000000000;
    SchoolNameList.WidthStyle := ssAuto;
    SchoolNameList.WidthPercent := 100.000000000000000000;
    SetEvent(SchoolNameList, Self, 'OnChange', 'OnChange_SelectedSchool');
    SchoolNameList.DataField := 'SchoolId';
    SchoolNameList.DataSource := DataSource;
    SchoolNameList.KeyField := 'Id';
    SchoolNameList.ListField := 'LocationName';
    SchoolNameList.ListSource := SchoolSource;
    InvoiceList.SetParentComponent(Self);
    InvoiceList.Name := 'InvoiceList';
    InvoiceList.Left := 54;
    InvoiceList.Top := 173;
    InvoiceList.Width := 145;
    InvoiceList.Height := 22;
    InvoiceList.ElementClassName := 'form-select form-control';
    InvoiceList.ElementFont := efCSS;
    InvoiceList.ElementPosition := epIgnore;
    InvoiceList.HeightPercent := 100.000000000000000000;
    InvoiceList.WidthStyle := ssAuto;
    InvoiceList.WidthPercent := 100.000000000000000000;
    InvoiceList.DataField := 'InvoiceId';
    InvoiceList.DataSource := DataSource;
    InvoiceList.KeyField := 'Id';
    InvoiceList.ListField := 'InvoiceRef';
    InvoiceList.ListSource := InvoiceSource;
    InvoiceGrossAmount.SetParentComponent(Self);
    InvoiceGrossAmount.Name := 'InvoiceGrossAmount';
    InvoiceGrossAmount.Left := 205;
    InvoiceGrossAmount.Top := 173;
    InvoiceGrossAmount.Width := 143;
    InvoiceGrossAmount.Height := 22;
    InvoiceGrossAmount.ChildOrder := 17;
    InvoiceGrossAmount.ElementClassName := 'form-control';
    InvoiceGrossAmount.ElementFont := efCSS;
    InvoiceGrossAmount.ElementPosition := epIgnore;
    InvoiceGrossAmount.HeightStyle := ssAuto;
    InvoiceGrossAmount.HeightPercent := 100.000000000000000000;
    InvoiceGrossAmount.ReadOnly := True;
    InvoiceGrossAmount.Text := 'InvoiceGrossAmount';
    InvoiceGrossAmount.WidthStyle := ssAuto;
    InvoiceGrossAmount.WidthPercent := 100.000000000000000000;
    InvoiceGrossAmount.DataField := 'GrossAmount';
    InvoiceGrossAmount.DataSource := InvoiceSource;
    SchoolIdList.SetParentComponent(Self);
    SchoolIdList.Name := 'SchoolIdList';
    SchoolIdList.Left := 54;
    SchoolIdList.Top := 145;
    SchoolIdList.Width := 75;
    SchoolIdList.Height := 22;
    SchoolIdList.ElementClassName := 'form-select form-control';
    SchoolIdList.ElementFont := efCSS;
    SchoolIdList.ElementPosition := epIgnore;
    SchoolIdList.HeightPercent := 100.000000000000000000;
    SchoolIdList.WidthStyle := ssAuto;
    SchoolIdList.WidthPercent := 100.000000000000000000;
    SetEvent(SchoolIdList, Self, 'OnChange', 'OnChange_SelectedSchool');
    SchoolIdList.DataField := 'SchoolId';
    SchoolIdList.DataSource := DataSource;
    SchoolIdList.KeyField := 'Id';
    SchoolIdList.ListField := 'Id';
    SchoolIdList.ListSource := SchoolSource;
    SchoolURNList.SetParentComponent(Self);
    SchoolURNList.Name := 'SchoolURNList';
    SchoolURNList.Left := 391;
    SchoolURNList.Top := 145;
    SchoolURNList.Width := 108;
    SchoolURNList.Height := 22;
    SchoolURNList.ElementClassName := 'form-select form-control';
    SchoolURNList.ElementFont := efCSS;
    SchoolURNList.ElementPosition := epIgnore;
    SchoolURNList.HeightPercent := 100.000000000000000000;
    SchoolURNList.WidthStyle := ssAuto;
    SchoolURNList.WidthPercent := 100.000000000000000000;
    SetEvent(SchoolURNList, Self, 'OnChange', 'OnChange_SelectedSchool');
    SchoolURNList.DataField := 'SchoolId';
    SchoolURNList.DataSource := DataSource;
    SchoolURNList.KeyField := 'Id';
    SchoolURNList.ListField := 'ExternalId';
    SchoolURNList.ListSource := SchoolSource;
    DataSource.Left := 304;
    DataSource.Top := 24;
    SchoolSource.SetParentComponent(Self);
    SchoolSource.Name := 'SchoolSource';
    SchoolSource.Left := 664;
    SchoolSource.Top := 24;
    InvoiceSource.SetParentComponent(Self);
    InvoiceSource.Name := 'InvoiceSource';
    InvoiceSource.Left := 664;
    InvoiceSource.Top := 104;
  finally
    PaymentMethodList.AfterLoadDFMValues;
    PaymentStateList.AfterLoadDFMValues;
    PaymentKindList.AfterLoadDFMValues;
    RemittanceDate.AfterLoadDFMValues;
    PaymentRef.AfterLoadDFMValues;
    RemittanceAmount.AfterLoadDFMValues;
    SchoolNameList.AfterLoadDFMValues;
    InvoiceList.AfterLoadDFMValues;
    InvoiceGrossAmount.AfterLoadDFMValues;
    SchoolIdList.AfterLoadDFMValues;
    SchoolURNList.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    SchoolSource.AfterLoadDFMValues;
    InvoiceSource.AfterLoadDFMValues;
  end;
end;

end.

